import { render } from "./NoticiasDestaque.vue?vue&type=template&id=735f6304"
import script from "./NoticiasDestaque.vue?vue&type=script&lang=js"
export * from "./NoticiasDestaque.vue?vue&type=script&lang=js"

import "./NoticiasDestaque.vue?vue&type=style&index=0&id=735f6304&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__